import { createFileRoute } from "@tanstack/react-router";
import { DocsLayout } from "@/shared/layouts/docs-layout";
import { HelpArticlePage } from "@/shared/pages/help/$";

export const Route = createFileRoute("/docs/$")({
  component: DocsArticleRoute,
});

function DocsArticleRoute() {
  const { _splat: slug } = Route.useParams();

  return (
    <DocsLayout>
      <HelpArticlePage slug={slug} />
    </DocsLayout>
  );
}
